import React, { lazy } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import legalRoutes from './Legal/routes';
import filerRoutes from './Filers/routes';
import reportsRoutes from './Reports/routes';
import publicationRoutes from './Publications/routes';
import dataRoutes from './Data/routes';
import municipalRoutes from './Municipal/routes';
import aboutRoutes from './About/routes';
import searchRoutes from './Search/routes';

const HomeView1 = lazy(() => import('./Home1'));
const LegalView = lazy(() => import('./Legal'));
const FilersView = lazy(() => import('./Filers'));
const ReportsView = lazy(() => import('./Reports'));
const DataView = lazy(() => import('./Data'));
const SearchView = lazy(() => import('./Search'));
const PublicationsView = lazy(() => import('./Publications'));
const MunicipalView = lazy(() => import('./Municipal'));
const AboutView = lazy(() => import('./About'));
const NotFoundView = lazy(() => import('./NotFound'));

//short link from OCPFORG in X: /r?f={cpfId} goes to the filer, /r?docId={id} goes to the search document
//need to add /r?rguid=<guid> and /r?d=<pdfId> later
const ShortLinkView = (params = {}): JSX.Element => {
  const queryParams = new URLSearchParams(useLocation().search);
  const docId = queryParams.get('docId');
  if (docId) {
    return <Navigate replace to={`/PublicSearch/ViewDocument?id=${encodeURIComponent(docId)}`} />;
  }
  return <FilersView {...params} />;
};

const routes = [
  {
    path: '/not-found',
    renderer: (params = {}): JSX.Element => <NotFoundView {...params} />,
  },
  {
    path: '/',
    renderer: (params = {}): JSX.Element => <HomeView1 {...params} />,
  },
  {
    path: '/index',
    renderer: (params = {}): JSX.Element => <HomeView1 {...params} />,
  },
  {
    path: '/home',
    renderer: (params = {}): JSX.Element => <HomeView1 {...params} />,
  },
  {
    path: '/home1',
    renderer: (params = {}): JSX.Element => <HomeView1 {...params} />,
  },
  {
    path: '/Legal',
    renderer: (params = {}): JSX.Element => <LegalView {...params} />,
  },
  {
    path: '/Filers',
    renderer: (params = {}): JSX.Element => <FilersView {...params} />,
  },
  {
    path: '/r', //link from OCPFORG in X
    renderer: (params = {}): JSX.Element => <ShortLinkView {...params} />,
  },
  {
    path: '/Reports',
    renderer: (params = {}): JSX.Element => <ReportsView {...params} />,
  },
  {
    path: '/Reports/Index',
    renderer: (params = {}): JSX.Element => <ReportsView {...params} />,
  },
  {
    path: '/Publications',
    renderer: (params = {}): JSX.Element => <PublicationsView {...params} />,
  },
  {
    path: '/Data',
    renderer: (params = {}): JSX.Element => <DataView {...params} />,
  },
  {
    path: '/Elections/MonthlyCharts', //previous link  to monthly charts
    renderer: (params = {}): JSX.Element => <DataView {...params} />,
  },
  {
    path: '/municipal',
    renderer: (params = {}): JSX.Element => <MunicipalView {...params} />,
  },
  {
    path: '/Search',
    renderer: (params = {}): JSX.Element => <SearchView {...params} />,
  },
  {
    path: '/PublicSearch',
    renderer: (params = {}): JSX.Element => <SearchView {...params} />,
  },
  {
    path: '/PublicSearch/Index',
    renderer: (params = {}): JSX.Element => <SearchView {...params} />,
  },
  {
    path: '/About',
    renderer: (params = {}): JSX.Element => <AboutView {...params} />,
  },
  ...legalRoutes,
  ...filerRoutes,
  ...reportsRoutes,
  ...publicationRoutes,
  ...dataRoutes,
  ...municipalRoutes,
  ...aboutRoutes,
  ...searchRoutes
];

export default routes;
